import { useCallback } from 'react';
import { Image } from '@components/common/Image';
import { UiKitButton } from '@components/common/ui-kit-button';
import { ButtonGroup } from '@features/Unsubscribe/components/ButtonGroup';
import { Container } from '@features/Unsubscribe/components/Container';
import { Title } from '@features/Unsubscribe/components/Title';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import type { TpWizardSteps } from '@features/Unsubscribe/types';
import { WIZARD_STEPS } from '../../сonstants';
import styles from './SpecialOffer.module.scss';
export const SpecialOffer = (props: TpWizardSteps) => {
  const {
    defaultEventOptions,
    trackUnsubscribeEvent
  } = useUnsubscribeAnalytics();
  const handleApplyDiscount = useCallback(() => {
    trackUnsubscribeEvent('cancel_special_offer_chosen', {
      variant: '1-apply discount'
    });
    props.wizard.goToStep(WIZARD_STEPS.HAPPY);
  }, [props.wizard, trackUnsubscribeEvent]);
  const handleCancel = useCallback(() => {
    trackUnsubscribeEvent('cancel_special_offer_chosen', {
      variant: '2-cancel anyway'
    });
    props.wizard.goToStep(WIZARD_STEPS.KEEP_IN_MIND);
  }, [props.wizard, trackUnsubscribeEvent]);
  return <Container className={styles.container} eventOnMounted="cancel_special_offer_opened" eventOptions={defaultEventOptions} data-sentry-element="Container" data-sentry-component="SpecialOffer" data-sentry-source-file="index.tsx">
      <Image className={styles.image} src="cancelling-gift.png" width={327} height={200} alt="cancelling-gift" data-sentry-element="Image" data-sentry-source-file="index.tsx" />

      <Title className={styles.title} data-sentry-element="Title" data-sentry-source-file="index.tsx">We have a special offer for you!</Title>

      <div className="double-grow">
        <p className={styles.advice}>
          Only <span className="highlight">$ 49.99</span>{' '}
          <span className={styles.oldPrice}>$ 149.99</span> <br /> for annual
          plan
        </p>

        <div className={styles.special}>
          <h3 className={styles.specialTitle}>70% off</h3>
          <p className={styles.specialDescription}>special for you</p>
        </div>
      </div>

      <ButtonGroup data-sentry-element="ButtonGroup" data-sentry-source-file="index.tsx">
        <UiKitButton fullWidth onClick={handleApplyDiscount} data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
          Apply discount
        </UiKitButton>
        <UiKitButton color="pure" onClick={handleCancel} data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
          Cancel anyway
        </UiKitButton>
      </ButtonGroup>
    </Container>;
};